import { Action, combineReducers } from '@ngrx/store';

import * as VertiLogin from './vertiLogin/reducer';
import * as Login from './login/reducer';
import * as RefreshLogin from './refreshLogin/reducer';

export const featureKey = 'authentications';

export interface AuthenticationsState {
  [VertiLogin.featureKey]: VertiLogin.State;
  [Login.featureKey]: Login.State;
  [RefreshLogin.featureKey]: RefreshLogin.State;
}

export interface State {
  [featureKey]: AuthenticationsState;
}

export const reducers = {
  [VertiLogin.featureKey]: VertiLogin.reducer,
  [Login.featureKey]: Login.reducer,
  [RefreshLogin.featureKey]: RefreshLogin.reducer,
};

export function combiner(state: AuthenticationsState | undefined, action: Action) {
  return combineReducers(reducers)(state, action);
}
